// File: stacks/workout/app/src/config/goals.js

// Centralized and categorized goals configuration.

// NOTE: Goals describe the *outcome/adaptation* (why you train). The training
// *method* (how you train) lives in WORKOUT_TYPE_OPTIONS. Items that merely named
// a method already present as a Workout Type (e.g. "Mobility & Flexibility",
// "Strength & Conditioning") have been removed to keep the two fields distinct.
export const GOAL_CATEGORIES = {
  "Physique & Aesthetics": [
    "Build Muscle",
    "Fat Loss",
    "Body Toning",
    "Body Recomposition",
  ],
  "Performance & Strength": [
    "Get Stronger",
    "Power Development",
    "Athletic Performance",
    "Sport-Specific Training",
  ],
  "Health & Wellness": [
    "General Fitness",
    "Build Endurance",
    "Stress Relief",
    "Improve Posture",
  ],
  "Skill Acquisition": [
    "Learn a New Lift",
    "Improve Form/Technique",
    "Bodyweight Mastery (Calisthenics)",
  ],
  "Longevity & Healthspan": [
    "VO2max Development",
    "Zone 2 Cardio",
    "Stability & Balance",
    "Longevity (Attia Protocol)",
  ],
  "Conditioning": [
    "Work Capacity",
    "Metabolic Conditioning (MetCon)",
  ],
};

// A flattened, unique, and sorted list of all goals.
const allGoalsSet = new Set();
Object.values(GOAL_CATEGORIES).forEach((categoryItems) => {
  categoryItems.forEach((item) => allGoalsSet.add(item));
});
export const ALL_GOALS = Array.from(allGoalsSet).sort();

// Formatted data structure for the enhanced Combobox component.
export const GOAL_OPTIONS_WITH_CATEGORIES = Object.entries(GOAL_CATEGORIES)
  .map(([category, items]) => ({
    label: category,
    options: items.map((item) => ({ value: item, label: item })),
  }))
  .sort((a, b) => a.label.localeCompare(b.label));

// A simpler, flat list for UIs that don't need categorization.
export const GOAL_OPTIONS = ALL_GOALS.map((g) => ({ value: g, label: g }));

// The goals most people pick, shown as cards (new programme, getting started);
// the full list stays a tap away.
export const TOP_GOALS = [
  ["Get Stronger", "Lift heavier over the weeks"],
  ["Build Muscle", "Size and shape"],
  ["General Fitness", "A bit of everything"],
  ["Fat Loss", "Burn more, keep muscle"],
  ["Build Endurance", "Go longer, recover faster"],
  ["Athletic Performance", "Power, speed, agility"],
];
